(function (module) {
    class GirdValudEditorHeader {
        agParams: $TSFixMe;
        eExportDataButton: $TSFixMe;
        eGoNextYearButton: $TSFixMe;
        eGoPreviousYearButton: $TSFixMe;
        eGui: $TSFixMe;
        eTogglePropagateButton: $TSFixMe;
        firstColumn: $TSFixMe;
        lastColumn: $TSFixMe;
        onExportDataListener: $TSFixMe;
        onGoNextYearListener: $TSFixMe;
        onGoPreviousYearListener: $TSFixMe;
        onTogglePropagateListener: $TSFixMe;
        constructor() { }

        init(agParams: $TSFixMe) {
            this.agParams = agParams;

            
            this.lastColumn = this.parseColId(_.last(this.agParams.columnApi.getAllGridColumns()));
            
            this.firstColumn = this.parseColId(_.chain(this.agParams.columnApi.getAllGridColumns()).filter((c: $TSFixMe) => c.pinned == null).first().value());

            this.eGui = document.createElement('div');
            this.eGui.innerHTML =
                `<div class="float-left toggle-propagate-wrapper mt-7">
                    <a class="toggle-propagate prop"></a>
                </div>
                <div class="buttons-nav">
                    <a class="glyphicon glyphicon-download-alt exportData" ng-click="$ctrl.export()"></a>
                    <a class="btn-nav chevron left small goPreviousYear"></a>
                    <a class="btn-nav chevron right small goNextYear"></a>
                </div>`;

            this.eTogglePropagateButton = this.eGui.querySelector('.toggle-propagate');
            this.eGoNextYearButton = this.eGui.querySelector('.goNextYear');
            this.eGoPreviousYearButton = this.eGui.querySelector('.goPreviousYear');
            this.eExportDataButton = this.eGui.querySelector('.exportData');

            this.onGoNextYearListener = this.onGoNextYear.bind(this);
            this.eGoNextYearButton.addEventListener('click', this.onGoNextYearListener);

            this.onGoPreviousYearListener = this.onGoPreviousYear.bind(this);
            this.eGoPreviousYearButton.addEventListener('click', this.onGoPreviousYearListener);

            this.onExportDataListener = this.onExportData.bind(this);
            this.eExportDataButton.addEventListener('click', this.onExportDataListener);

            if (this.agParams.showPropagateButton) {
                this.onTogglePropagateListener = this.onTogglePropagate.bind(this);
                this.eTogglePropagateButton.addEventListener('click', this.onTogglePropagateListener);
                $(this.eTogglePropagateButton).addClass(this.agParams.$ctrl.gridOptions.propagateData ? 'prop' : 'notprop');
            }
            else {
                this.eGui.removeChild(this.eGui.querySelector('.toggle-propagate-wrapper'));
            }
        }

        getGui() {
            return this.eGui;
        }

        onGoNextYear() {
            
            const column = _.chain(this.agParams.columnApi.getAllDisplayedVirtualColumns()).filter((c: $TSFixMe) => c.pinned == null).last().value();
            const colData = this.parseColId(column);
            const nextYear = colData.year + 1;

            if (nextYear > this.lastColumn.year) {
                this.agParams.api.ensureColumnVisible(`${this.lastColumn.year}_${this.lastColumn.month}`);
            }
            else {
                this.agParams.api.ensureColumnVisible(`${nextYear}_1`);
            }
        }

        onGoPreviousYear() {
            
            const column = _.chain(this.agParams.columnApi.getAllDisplayedVirtualColumns()).filter((c: $TSFixMe) => c.pinned == null).first().value();
            const colData = this.parseColId(column);
            const prevYear = colData.year - 1;

            if (prevYear <= this.firstColumn.year) {
                this.agParams.api.ensureColumnVisible(`${this.firstColumn.year}_${this.firstColumn.month}`);
            }
            else {
                this.agParams.api.ensureColumnVisible(`${prevYear}_1`);
            }
        }
        parseColId(column: $TSFixMe) {
            return this.agParams.$ctrl.gridValueEditorService.parseColId(column);
        }

        onExportData() {
            this.agParams.$ctrl.export();
        }

        onTogglePropagate() {
            const jQueryObj = $(this.eTogglePropagateButton);
            if (jQueryObj.hasClass('prop')) {
                jQueryObj.addClass('notprop');
                jQueryObj.removeClass('prop');
                this.agParams.$ctrl.setPropagateData(false);
            } else {
                jQueryObj.removeClass('notprop');
                jQueryObj.addClass('prop');
                this.agParams.$ctrl.setPropagateData(true);
            }
        }

        destroy() {
            if (this.onTogglePropagateListener) {
                this.eTogglePropagateButton.removeEventListener('click', this.onTogglePropagateListener);
            }
            this.eGoNextYearButton.removeEventListener('click', this.onGoNextYearListener);
            this.eGoPreviousYearButton.removeEventListener('click', this.onGoPreviousYearListener);
            this.eExportDataButton.removeEventListener('click', this.onExportDataListener);
        }
    }

    module.value('GirdValudEditorHeader', GirdValudEditorHeader);


})(angular.module('gridValueEditor'));
